import { render, staticRenderFns } from "./RecapSDD.vue?vue&type=template&id=ddf1cbe4&"
import script from "./RecapSDD.vue?vue&type=script&lang=js&"
export * from "./RecapSDD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports